import { useSelector } from 'react-redux';
import { SpaceTabSkelton } from 'api/space';
import { MentionData } from 'components/molecules/mention';
import { RootState } from 'data';
import { useNativeMembers } from 'data/members/hooks/use-store-members';
import { useGetAllDocumentTemplates } from 'data/templates/documents/hooks/use-get-all-document-templates';
import { useGetAllTasks } from 'data/templates/projects';
import { useTranslation } from 'hooks/use-translation';

interface Config {
  forPrivateContext?: boolean;
}

export const useTemplateMentionsData = (
  config?: Config,
): Required<MentionData> => {
  const { forPrivateContext } = config || {};
  const members = useNativeMembers();
  const { byId: teamsById } = useSelector(({ teams }: RootState) => teams);
  const { documents, publicSpaceTabs, privateSpaceTabs, isLoading } =
    useGetAllDocumentTemplates();
  const allTasks = useGetAllTasks();
  const docTabTitle = useTranslation('templates.documents.mentions.title');

  const documentsTemplateMentions = forPrivateContext
    ? [...publicSpaceTabs, ...privateSpaceTabs, ...documents]
    : [...publicSpaceTabs, ...documents];

  return {
    members: {
      items: {
        users: members.users ?? [],
        // teams: members.teams ?? [],
        teams: Object.values(teamsById),
        notInProject: [],
      },
      isLoading: members.loading,
    },
    spaceTabs: {
      items: documentsTemplateMentions as SpaceTabSkelton[],
      isLoading,
      title: docTabTitle,
    },
    tasks: {
      items: Object.values(allTasks).filter((t) => !t.isNew),
      isLoading: false,
    },
  };
};
